import React, {useEffect, useState} from 'react'
import i18n from 'i18next'
import actions from 'redux-auto'
import Headline from '#components/a/Headline'
import PageHeader from '#components/m/PageHeader'
import UploadFeedbackAnAzubiModal from '#components/o/Feedback/UploadFeedbackAnAzubiModal'
import UploadFeedbackAsAzubiModal from '#components/o/Feedback/UploadFeedbackAsAzubiModal'
import FeedbackOverview from '#components/o/Feedback/FeedbackOverview'
import FeedbackVorlagenOverview from '#components/o/Feedback/FeedbackVorlagenOverview'
import {usePermissions} from '#hooks/usePermissions'
import Api from '#services/api'

function Feedback() {
  const permissions = usePermissions()
  const [feedbackList, setFeedbackList] = useState([])

  useEffect(() => {
    const execute = async () => {
      try {
        if (permissions.feedback.canGetFeedback) {
          const result = await Api.getMyFeedback()
          setFeedbackList(result)
        }
      } catch (e) {
        actions.error.writeError({error: e})
      }
    }
    execute()
  }, [])

  const onUploadSuccess = newFeedback => {
    setFeedbackList([newFeedback, ...feedbackList])
  }

  const pageHeaderButton = () => {
    if (permissions.feedback.canUploadFeedbackAnAzubi) {
      return <UploadFeedbackAnAzubiModal onSuccess={onUploadSuccess} />
    }
    if (permissions.feedback.canUploadFeedbackAsAzubi) {
      return <UploadFeedbackAsAzubiModal onSuccess={onUploadSuccess} />
    }
    return undefined
  }

  return (
    <div className="feedback-page">
      <PageHeader
        headline={<Headline importance={1} modifier="section" text={i18n.t('menu_item_feedback')} />}
        button={pageHeaderButton()}
      />
      <FeedbackVorlagenOverview />
      <FeedbackOverview feedbackList={feedbackList} />
    </div>
  )
}

export default Feedback
